let elementsForm,contLogin = 1;

function validationForm(elementsForm,contLogin)
{
  for(let i=0;i<elementsForm.length;i++){
    if ( $.trim($("#"+elementsForm[i]).val()) == "" ) {
      contLogin = 0;
    }
  }
  return contLogin;
}

$('.btnFormApi').click(function () {
    $('#formApi').submit();
});
/*
$('#ch').change(function(){
  $('.boy_1').css('display','none')
  $('.boy_2').css('display','none')
  if( parseInt( $('#ch').val() ) == 1){
    $('.boy_1').css('display','block')
  }
  if( parseInt( $('#ch').val() ) == 2){
    $('.boy_1').css('display','block')
    $('.boy_2').css('display','block')
  }
})
*/
$('#formApi').on('submit',function (e) {
    e.preventDefault();
    elementsForm = [
        "CheckIn",
        "CheckOut",
        "ad"
        //"ch",
        //"ag_1",
        //"ag_2",
        //"Code"
    ];
  
    contLogin = validationForm(elementsForm,contLogin = 1);
    if(contLogin == 0)
    {
      swal({
        text: "Debes digitar todos los datos requeridos",
        icon: imageURL,
        button: "OK",
      });
      return false;
    }
  
    let data = $(this).serialize();

    let CheckIn = $('#CheckIn').val()
    let partes = CheckIn.split('-');
    let textoInvertido = partes.reverse().join('-');
    let textoSinGuiones = textoInvertido.replace(/-/g, '');
    CheckIn = textoSinGuiones
    
    let CheckOut = $('#CheckOut').val()
    partes = CheckOut.split('-');
    textoInvertido = partes.reverse().join('-');
    textoSinGuiones = textoInvertido.replace(/-/g, '');
    CheckOut = textoSinGuiones
    
    let ad = $('#ad').val()
    //let ch = $('#ch').val()
    //let ag_1 = $('#ag_1').val()
    //let ag_2 = $('#ag_2').val()
    let Code = $('#Code').val()

    //let url = "https://book.omnibees.com/hotelresults?c=1966&q=3191&currencyId=23&lang=es-ES&hotel_folder=&NRooms=1&CheckIn="+CheckIn+"&CheckOut="+CheckOut+"&ad="+ad+"&ch="+ch+"&ag="+ag_1+";"+ag_2+"&Code="+Code
    let url = "https://book.omnibees.com/hotelresults?c=1966&q=3191&currencyId=23&lang=es-ES&hotel_folder=&NRooms=1&CheckIn="+CheckIn+"&CheckOut="+CheckOut+"&ad="+ad+"&Code="+Code
    window.open(url, '_blank');
});


$('.btnFormApi_2').click(function () {
  $('#formApi_2').submit();
});
$('#formApi_2').on('submit',function (e) {
  e.preventDefault();
  elementsForm = [
      "CheckIn_2",
      "CheckOut_2",
      "ad_2"
  ];

  contLogin = validationForm(elementsForm,contLogin = 1);
  if(contLogin == 0)
  {
    swal({
      text: "Debes digitar todos los datos requeridos",
      icon: imageURL,
      button: "OK",
    });
    return false;
  }

  let data = $(this).serialize();

  let CheckIn = $('#CheckIn_2').val()
  let partes = CheckIn.split('-');
  let textoInvertido = partes.reverse().join('-');
  let textoSinGuiones = textoInvertido.replace(/-/g, '');
  CheckIn = textoSinGuiones
  
  let CheckOut = $('#CheckOut_2').val()
  partes = CheckOut.split('-');
  textoInvertido = partes.reverse().join('-');
  textoSinGuiones = textoInvertido.replace(/-/g, '');
  CheckOut = textoSinGuiones
  
  let ad = $('#ad_2').val()
  let Code = $('#Code_2').val()

  let url = "https://book.omnibees.com/hotelresults?c=1966&q=3191&currencyId=23&lang=es-ES&hotel_folder=&NRooms=1&CheckIn="+CheckIn+"&CheckOut="+CheckOut+"&ad="+ad+"&Code="+Code
  window.open(url, '_blank');
});